// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/form_template/v1/form_template.proto (package fingertip.creator.form_template.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, proto3, StringValue } from "@bufbuild/protobuf";
import { Media, MediaValue } from "../../../common/type/v1/media_pb.js";
import { FormTemplate } from "../../../common/type/v1/form_template_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { PageThemeSchema } from "../../../common/type/v1/page_theme_schema_pb.js";
import { FormTheme } from "../../../common/type/v1/form_theme_pb.js";
import { FormField } from "../../../common/type/v1/form_field_pb.js";
import { Page } from "../../../common/type/v1/page_pb.js";
import { Site } from "../../../common/type/v1/site_pb.js";
import { PageTheme } from "../../../common/type/v1/page_theme_pb.js";

/**
 * @generated from message fingertip.creator.form_template.v1.CreateFormTemplateRequest
 */
export const CreateFormTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.CreateFormTemplateRequest",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "preview_form_template_index", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "banner_media", kind: "message", T: Media },
    { no: 6, name: "form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "thank_you_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "form_theme_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "custom_recipients", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "use_custom_recipients", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.CreateFormTemplateResponse
 */
export const CreateFormTemplateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.CreateFormTemplateResponse",
  () => [
    { no: 1, name: "form_template", kind: "message", T: FormTemplate },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.GetFormTemplatesRequest
 */
export const GetFormTemplatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.GetFormTemplatesRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "business_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.PreviewFormTemplate
 */
export const PreviewFormTemplate = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.PreviewFormTemplate",
  () => [
    { no: 1, name: "preview_form_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "service", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.GetFormTemplatesResponse
 */
export const GetFormTemplatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.GetFormTemplatesResponse",
  () => [
    { no: 1, name: "form_templates", kind: "message", T: FormTemplate, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
    { no: 4, name: "preview_form_templates", kind: "message", T: PreviewFormTemplate, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.SuggestedFormTemplate
 */
export const SuggestedFormTemplate = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.SuggestedFormTemplate",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "thank_you_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.GetSuggestedFormTemplatesRequest
 */
export const GetSuggestedFormTemplatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.GetSuggestedFormTemplatesRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "past_suggestions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.GetSuggestedFormTemplatesResponse
 */
export const GetSuggestedFormTemplatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.GetSuggestedFormTemplatesResponse",
  () => [
    { no: 1, name: "suggested_form_templates", kind: "message", T: SuggestedFormTemplate, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.CustomRecipients
 */
export const CustomRecipients = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.CustomRecipients",
  () => [
    { no: 1, name: "emails", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.UpdateFormTemplateRequest
 */
export const UpdateFormTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.UpdateFormTemplateRequest",
  () => [
    { no: 1, name: "form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "message", T: StringValue },
    { no: 3, name: "description", kind: "message", T: StringValue },
    { no: 4, name: "banner_media", kind: "message", T: MediaValue },
    { no: 5, name: "thank_you_message", kind: "message", T: StringValue },
    { no: 6, name: "new_form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "form_theme_content", kind: "message", T: PageThemeSchema },
    { no: 8, name: "button_text", kind: "message", T: StringValue },
    { no: 9, name: "custom_recipients", kind: "message", T: CustomRecipients },
    { no: 10, name: "use_custom_recipients", kind: "message", T: BoolValue },
    { no: 11, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.UpdateFormTemplateResponse
 */
export const UpdateFormTemplateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.UpdateFormTemplateResponse",
  () => [
    { no: 1, name: "form_template", kind: "message", T: FormTemplate },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.GetFormTemplateRequest
 */
export const GetFormTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.GetFormTemplateRequest",
  () => [
    { no: 1, name: "form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.GetFormTemplateResponse
 */
export const GetFormTemplateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.GetFormTemplateResponse",
  () => [
    { no: 1, name: "form_template", kind: "message", T: FormTemplate },
    { no: 2, name: "form_theme", kind: "message", T: FormTheme },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.DeleteFormTemplateRequest
 */
export const DeleteFormTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.DeleteFormTemplateRequest",
  () => [
    { no: 1, name: "form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.DeleteFormTemplateResponse
 */
export const DeleteFormTemplateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.DeleteFormTemplateResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.GetFormTemplatePublicRequest
 */
export const GetFormTemplatePublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.GetFormTemplatePublicRequest",
  () => [
    { no: 1, name: "form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "form_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.GetFormTemplatePublicResponse
 */
export const GetFormTemplatePublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.GetFormTemplatePublicResponse",
  () => [
    { no: 1, name: "form_template", kind: "message", T: FormTemplate },
    { no: 2, name: "form_theme", kind: "message", T: FormTheme },
    { no: 3, name: "form_fields", kind: "message", T: FormField, repeated: true },
    { no: 4, name: "page", kind: "message", T: Page },
    { no: 5, name: "site", kind: "message", T: Site },
    { no: 6, name: "page_theme", kind: "message", T: PageTheme },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.GetFormStatsRequest
 */
export const GetFormStatsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.GetFormStatsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.GetFormStatsResponse
 */
export const GetFormStatsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.GetFormStatsResponse",
  () => [
    { no: 1, name: "form_responses_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.DuplicateFormTemplateRequest
 */
export const DuplicateFormTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.DuplicateFormTemplateRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_template.v1.DuplicateFormTemplateResponse
 */
export const DuplicateFormTemplateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_template.v1.DuplicateFormTemplateResponse",
  () => [
    { no: 1, name: "form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "form_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

